import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import React from 'react';
// -*- mode: jsx;-*-
import PureRenderMixin from '../common/external-adapters/pureRenderMixinAdapter.js';

import Filters from './filters.js';
import SearchResults from './searchResults.js';
import SortSelector from './sortSelector.js';
import Breadcrumb from './breadcrumb.js';
import { LoadingEllipsis } from '../common/LoadingEllipsis.js';
import { BASIC_MAP_URL, mapFeatureCalloutUtils } from './mapFeatureCalloutUtils.js';
import { Svg } from '../common/Svg.js';
import Sticky from 'react-sticky-el';

/* global dc */
import { SearchBoxes } from '../common/SearchBoxes.js';

/**
 * The map-toggle map-link.
 */
const MapToggle = (props) => {
    // Updating the map-url with your location parameters requires Uri.js, which isn't present on the server. So we
    // update this url on-mount.
    const [mapUrl, setMapUrl] = React.useState(BASIC_MAP_URL);
    React.useEffect(() => {
        setMapUrl(mapFeatureCalloutUtils.getMapFeatureUrl(props.searchURL));
    }, [props.searchURL]);

    return (
        <div>
            <Sticky className="search-sticky-parent" stickyClassName="fixed floating-search-fixed">
                <div className="container">
                    <div className="floating-search">
                        <a className="search-toggle" tabIndex="0" aria-label="view map" href={mapUrl}>
                            <div className="list check"><Svg icon="list"/>List</div>
                            <div className="map"><Svg icon="location"/>Map</div>
                        </a>
                        <SearchBoxes {...props} />
                    </div>
                </div>
            </Sticky>
        </div>
    );
};
MapToggle.propTypes = {
    searchURL: PropTypes.string.isRequired,
};

const SearchLayout = createReactClass({
    mixins: [PureRenderMixin],
    propTypes: {
        callbacks: PropTypes.objectOf(PropTypes.func).isRequired,
        searchURL: PropTypes.string.isRequired,
        isMapFeatureEnabled: PropTypes.bool,
    },

    render: function () {
        const props = this.props;
        let busy, loadingSkeleton;
        const loadingItems = [];

        //hard coding a value here to just make the placeholder section roughly match a typical search page height.
        for(let i = 0; i < 13; i++){
            if(i != 5) {
                loadingItems.push(
                    <div className="skeleton-card">
                        <div className="left">
                            <div className="skeleton-image"></div>
                        </div>
                        <div className="right">
                            <div className="skeleton-title"></div>
                            <div className="skeleton-body"></div>
                            <div className="skeleton-body"></div>
                            <div className="skeleton-location"><div className="skeleton-school-name"></div> <div className="skeleton-city-name"></div></div>
                        </div>
                    </div>
                );
            } else {
                loadingItems.push(
                    <div className="essentials-section">
                        <div className="essentials-header"><h3>Add-on basics for a teacher nearby</h3></div>
                        <div className="selected-essentials">
                            <a className="essentials-list-card">
                            <div className="essentials-description">
                                <div className="top-supply"></div>
                                <div className="list-details">
                                    <div><h3 className="header"></h3>
                                        <span className="teacher-secondary-info"></span>
                                    </div>
                                </div>
                            </div>
                            <button className="button-primary small essentials"><span className="name">Add to cart</span><span className="price">$10</span></button>
                            </a>
                            <a className="essentials-list-card">
                                <div className="essentials-description">
                                    <div className="top-supply"></div>
                                    <div className="list-details">
                                        <div><h3 className="header"></h3>
                                            <span className="teacher-secondary-info"></span>
                                        </div>
                                    </div>
                                </div>
                                <button className="button-primary small essentials"><span className="name">Add to cart</span><span className="price">$10</span></button>
                            </a>
                        </div>
                    </div>
                );
            }
        }
        if (props.callbacks.isLoading()) {
            busy = true;
            loadingSkeleton = (
                <div className="loading-skeleton">
                    {loadingItems}
                </div>);
        }

        return (
            <div className="search-results">
                <div className="container">
                    <h1 className="screenreader-only">Classroom Projects</h1>
                    {busy ? <LoadingEllipsis className="page-loader" /> : ''}
                    <div className="standard-search">
                        <MapToggle {...props} />
                        <div className="active-filters-sort">
                            <SortSelector {...props} />
                            <Breadcrumb {...props} />
                        </div>
                    </div>
                    <div className="fluid-container">
                        <div className="col col3">
                            <h2 className="screenreader-only">Search Filters</h2>
                            <Filters {...props} mapFeatureCallout={null}/>
                        </div>
                        <div aria-busy={busy} aria-live="polite" aria-atomic="true" className="col col9 results-holder">
                            <h2 className="screenreader-only">Project list</h2>
                            {busy ? loadingSkeleton : <SearchResults {...props} />}
                        </div>
                    </div>
                </div>
            </div>
        );
    },
});

export default SearchLayout;
